import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteLiquidationDifferenceReason } from '../../../../actions';

const LiquidationDifferenceReasonDeleteButton = ({
  dispatchDeleteLiquidationDifferenceReason,
  liquidationDifferenceReasonId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteLiquidationDifferenceReason({ liquidationDifferenceReasonId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

LiquidationDifferenceReasonDeleteButton.propTypes = {
  dispatchDeleteLiquidationDifferenceReason: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  liquidationDifferenceReasonId: PropTypes.number.isRequired,
};

LiquidationDifferenceReasonDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteLiquidationDifferenceReason: deleteLiquidationDifferenceReason,
};

export default connect(null, mapDispatchToProps)(LiquidationDifferenceReasonDeleteButton);
